import Card from 'react-bootstrap/Card';

function CardNews({title, date, description}) {
  return (
  <Card style={{ margin: '8px' }}>
    <Card.Body>
            <Card.Title >{title}</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">{date}</Card.Subtitle>
            <Card.Text>
            {description}
            </Card.Text>
        </Card.Body>
    </Card>
  );
}

export default CardNews;